// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__119nL","productName":"Table_productName__2QNI-"};